export const DEFAULT_ALT_TEXT =
  "Unrivaled Group Fitness classes. Unparalleled Personal Training. Studios that inspire you to perform and luxury amenities that keep you feeling your best.";
export const TAGLINE = "It’s Not Fitness. It’s Life.";
export const OFFLINE_CLUBS_DESCRIPTION =
  "Membership for the {{CLUB_NAME}} is best setup with a Membership Advisor. Please share your details and we will reach out to you shortly.";
